import { CodebaseProductData, ProductComplete } from '../types/models';

export const getCodeProductBlank = (sku: string): CodebaseProductData => ({
  attributes: {
    sku,
    categoryDetails: {
      primaryCategory: undefined,
    },
    productTags: [],
  },
  media: {},
  content: {},
});

export const ProductPageProduct = (): ProductComplete => {
  return {
    attributes: {
      globalId: 0,
      variantId: 0,
      manualSoldOut: false,
      shopifyAvailable: true,
      handle: '',
      tags: [],
      sku: '',
      price: 0,
      variantDetails: undefined,
      bundleDetails: undefined,
      productHandle: '',
      maxCartQuantity: 5,
      productFlags: [],
      age: 0,
      shopifyCategory: '',
      compareAtPrice: 0,
      // variants: [],
      categoryDetails: {
        primaryCategory: undefined,
      },
      productTags: [],
    },
    content: {
      title: '',
      specialFeatures: [],
      productAccordions: [],
      faqAccordion: {
        title: '',
        accordions: [],
      },
      customComponents: [],
      productCardBadge: undefined,
      productImageBadge: undefined,
      styleTags: [],
      valuePrice: undefined,
      productOptionSelector: undefined,
      productOptionSelectorDetails: undefined,
      textBelowProductTitle: undefined,
      belowTitleIcon: undefined,
      customButtonText: '',
      pill: {
        variant: undefined,
        text: '',
      },
      description: {
        title: '',
        body: '',
        bulletpoints: [],
        customBlurb: {
          icon: {
            src: '',
            height: 0,
            width: 0,
            aspectRatio: 0,
            alt: '',
          },
          text: '',
        },
      },
      disclaimer: '',
      colourScheme: {},
    },
    media: {
      carousel: undefined,
      featureImage: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
      customProductAsset: {
        bundleImage: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
        upsellImage: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
        overlayImage: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
      },
      doubleWide: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
      cart: {
        src: '',
        height: 0,
        width: 0,
        aspectRatio: 0,
        alt: '',
      },
      selectorImage: { src: '', height: 0, width: 0, aspectRatio: 0, alt: '' },
    },
    seo: {
      title: '',
      description: '',
    },
    template: {
      name: '',
    },
    variantProducts: undefined,
    bundleDefinition: undefined,
  };
};
